module.exports = __webpack_public_path__ + "img/newInt-main-icon.0e07b19c.svg";